<template>
  <div>
    <b-modal
             ref="clientModal"
             title="Create new client"
             @shown="URLsList=''"
    >
      <template slot="modal-header">
        <h3>{{id?'Update client':'Create new client'}}</h3>
        <b-button @click="closeModal" variant="light" class="btn-close"><i class="icon-close"></i></b-button>
      </template>
      <div class="modal-content">
        <div class="mb-20">
          <label for="clientName">Client name</label>
          <div class="input-holder">
            <b-input v-model='clientName' id="clientName" placeholder="The name of the client"></b-input>
          </div>
        </div>
        <div class="mb-2">
          <label for="clientLogo">Upload client logo</label>
          <div class="image-preview" id="clientLogo">
            <input type="file" ref="fileInput" class="hidden" @input="imageUpload" />
            <div class="preview-box" :class="{'no-bg':logoPreview}" @click="selectFile">
              <div v-if="logoPreview"
                   :style="'background-image: url('+logoImage+')'"
                   class="img-holder img-preview"
              >
                <div class="ih-img-overlay">
                  <button class="btn-action blue" @click="imageUpload"><i class="icon-arrow-up"></i></button>
                  <button class="btn-action" @click.stop="clearLogoPreview"><i class="icon-delete"></i></button>
                </div>
              </div>
              <div class="img-holder" v-else>
                <img src="@/assets/img/upload_picture.svg" alt="" width="55">
                <p class="img-title">Choose image</p>
              </div>
            </div>

          </div>
        </div>
      </div>

      <template slot="modal-footer">
        <b-button @click="closeModal" variant="light-grey">Cancel</b-button>
        <b-button @click="saveClient" :disabled="fileLoading||!imageFile||!clientName">{{id?'Save client':'Add client'}}</b-button>
      </template>

    </b-modal>

  </div>
</template>

<script>
import axios from '../_helpers/axios';
import { processApiError } from '../_helpers';
import { apiUrl } from 'config';
import helpers from '../_mixins/helpers';

export default {
  name: 'ClientCard',
  components: {
    'value-item': () => import('@/components/ValueItem.vue'),
  },
  mixins: [helpers],
  data: () => ({
    clientId: null,
    clientName: '',
    selected_client_id: null,
    file: null,
    fileLoading: false,
    uploadPercentage: 0,
    logoPreview: null,
    imageFile: null,
    logoChanged: false,
  }),
  props: {
    id: {
      type: Number,
    },
  },
  mounted() {
    this.file = null;
    this.clientId = this.id;
  },
  methods: {
    clearLogoPreview() {
      this.logoPreview = null;
      this.imageFile = null;
      this.$refs.fileInput.value = '';
    },
    selectFile() {
      this.$refs.fileInput.click();
    },
    show(id) {
      if (id) {
        this.clientId = id;
      }
      if (this.isNew) {
        this.clientName = '';
        this.logoPreview = null;
        this.clientId = 0;
      } else {
        const clientData = this.$store.state.refs.clients.find(
          e => e.id === this.id
        );
        if (clientData) {
          this.clientName = clientData.name;
          this.logoPreview = clientData.logo_url;
        }
      }
      this.$refs.clientModal.show();
    },
    closeModal() {
      this.$refs.clientModal.hide();
    },
    async saveClient() {
      this.fileLoading = true;
      let formData = new FormData();

      formData.append('file', this.imageFile);
      let avatarData;
      if (this.logoChanged) {
        avatarData = await axios
          .post(`${apiUrl}/api/services/imageUpload`, formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          })
          .then(resp => {
            let imgUrl = resp.fileName;
            return {
              imgUrl: imgUrl,
              localImgUrl: resp.fileName,
            };
          })
          .catch(err => {
            processApiError(err);
            this.$emit('finish', err);
          })
          .finally(() => {
            this.fileLoading = false;
          });
        this.logoPreview = avatarData.imgUrl;
      }

      if (avatarData) {
        let requestOptions = {
          refName: 'clients',
          refData: { name: this.clientName, logo_url: this.logoPreview },
        };
        let requestUrl = `${apiUrl}/api/refs/new`;
        if (this.clientId) {
          requestUrl = `${apiUrl}/api/refs/save`;
          requestOptions.refData.id = this.clientId;
        }

        const clientId = await axios
          .post(requestUrl, requestOptions)
          .then(response => {
            this.$store.commit('refs/newItemSuccess', response);
            return this.clientId || response[0].insertId;
          })
          .catch(error => {
            console.log(error);
            return Promise.reject(error);
          });

        if (clientId) {
          this.$emit('saved', {id:clientId,name:this.clientName});
          this.closeModal();
        }
      }
    },
    imageUpload() {
      // debugger
      const fileInput = this.$refs.fileInput;
      if (fileInput.files && fileInput.files[0]) {
        var reader = new FileReader();

        reader.onload = e => {
          this.logoPreview = e.target.result;
          this.imageFile = fileInput.files[0];
          this.logoChanged = true;
        };

        reader.readAsDataURL(fileInput.files[0]);
      }
    },
    finish(result) {
      this.$emit('finish', result);
      this.$refs.uploadScreenshot.hide();
    },
    cleanUploadFileAttrs() {
      this.file = '';
      this.$refs.fileinput.$refs.input.value = '';
      this.uploadPercentage = 0;
    },
  },
  computed: {
    isNew() {
      return !this.clientId;
    },
    logoImage() {
      if (this.logoPreview.substr(0, 4) === 'data') {
        return this.logoPreview;
      } else {
        return this.addImgAddress(this.logoPreview);
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import '../assets/_scss/_component-base';
@import '../assets/_scss/components/modal';

.preview-box {
  position: relative;
  height: 180px;
  background: rgba(6, 140, 255, 0.05);
  border: 2px dashed #068cff;
  border-radius: 6px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  cursor: pointer;
  &.no-bg {
    background: none;
  }
  .img-preview {
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    width: 80%;
    height: 80%;
  }
}
.img-title {
  font-size: 14px;
  color: #2c5171;
  margin-top: 20px;
  opacity: 0.8;
}
</style>
